export function createFundApi(baseUrl) {
  return {
    fund: {
      getFund: (id) => `${baseUrl}/v1/funds/${id}/`,
      appLink: (id) => `${baseUrl}/v1/funds/${id}/links/`,
    },
  };
}
